import {Typography} from "@mui/material";

export default function Categories() {
    return (
        <Typography variant={"h2"} sx={{fontSize: "30pt"}}>Kategorien</Typography>
    );
}